import {useEffect, useRef, useState} from "react";
import {FiArrowUpRight, FiMenu, FiX} from "react-icons/fi";
import {PROFILE, RESUME_PDF_PATH} from "../../data/resume";

const NAV_LINKS = [
    {name: "Work", href: "#projects"},
    {name: "Capabilities", href: "#skills"},
    {name: "Experience", href: "#experience"},
    {name: "Contact", href: "#contact"},
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const toggle = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        if (!open) return;
        const close = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                setOpen(false);
                toggle.current?.focus();
            }
        };
        document.addEventListener("keydown", close);
        return () => document.removeEventListener("keydown", close);
    }, [open]);
    return (
        <header className="site-header">
            <nav className="shell nav-inner" aria-label="Main navigation">
                <a className="wordmark" href="#top" onClick={() => setOpen(false)}>{PROFILE.name}<span aria-hidden="true">.</span></a>
                <div className="desktop-nav">
                    {NAV_LINKS.map(link => <a key={link.href} href={link.href}>{link.name}</a>)}
                    <a className="nav-resume" href={RESUME_PDF_PATH} download>Résumé <FiArrowUpRight aria-hidden="true" /></a>
                </div>
                <button ref={toggle} type="button" className="menu-toggle" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen(!open)}>
                    {open ? <FiX aria-hidden="true" /> : <FiMenu aria-hidden="true" />}
                </button>
                {open && <div className="mobile-nav" id="mobile-menu">
                    {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)}>{link.name}</a>)}
                    <a href={RESUME_PDF_PATH} download onClick={() => setOpen(false)}>Download résumé</a>
                </div>}
            </nav>
        </header>
    );
};
